// extracted by mini-css-extract-plugin
export default {"leran_and_by":"HeroSection_leran_and_by__2qrTo"};